function parseVars (content, args) {
	Object.entries(args).forEach(function (entry) {
		content = content.replaceAll('${' + entry[0] + '}', entry[1]);
	});

	return content;
}

function calcRes (val, formula) {
	return eval(formula);
}

document.querySelectorAll('#range-calculator').forEach(function (el) {
	var parseVarEls = el.querySelectorAll('[data-parse-vars]');
	var formulaEl = el.querySelector('[data-formula]');
	var formula = JSON.parse(formulaEl.dataset.formula);

	// Store original HTML
	parseVarEls.forEach(function (pve) {
		pve.dataset.originalInnerHTML = pve.innerHTML;
	});

	function update () {
		parseVarEls.forEach(function (pve) {
			pve.innerHTML = parseVars(pve.dataset.originalInnerHTML, {
				val: parseFloat(formulaEl.value).toLocaleString(undefined, {maximumFractionDigits: 0}),
				res: parseFloat(calcRes(formulaEl.value, formula)).toLocaleString(undefined, {maximumFractionDigits: 0}),
				formula: formula
			});
		});
	}

	update();

	formulaEl.addEventListener('input', update);
});